import React from 'react'
import './StatsCards.scss'
import rankIcon from '../../../../assets/rank-icon.svg'
import pointsIcon from '../../../../assets/points-icon.svg'
import levelIcon from '../../../../assets/level-icon.svg'
import { useTranslation } from 'react-i18next'

const StatsCards = ({ boardType = 'team', leaderboardData }) => {
  const isTeamBoard = boardType === 'team'

  const { rank, progress, total_points, level, updated_at } = leaderboardData

  const getChangeText = value => {
    const lastUpdated = new Date(updated_at)
    const now = new Date()
    const diffInMonths =
      now.getMonth() -
      lastUpdated.getMonth() +
      12 * (now.getFullYear() - lastUpdated.getFullYear())
    if (diffInMonths === 0) {
      return 'this month'
    }
    if (diffInMonths === 1) {
      return 'last month'
    }
    return `${diffInMonths} months ago`
  }
  const { t } = useTranslation()

  const statsData = [
    {
      id: 'rank',
      title: t('v4:your_rank'),
      value: rank || 'N/A',
      change: `+${progress}`,
      changeText: getChangeText(updated_at),
      isPositive: true,
      icon: <img src={rankIcon} alt="Rank icon" width="64" height="65" />,
      iconBg: '#dbeafe'
    },
    {
      id: 'points',
      title: t('v4:your_points'),
      value: total_points,
      change: '+15%',
      changeText: getChangeText(updated_at),
      isPositive: true,
      icon: <img src={pointsIcon} alt="Points icon" width="64" height="65" />,
      iconBg: '#dcfce7'
    },
    isTeamBoard
      ? {
          id: 'level',
          title: t('v4:your_level'),
          value: level || 'N/A',
          change: '+1 lvl',
          changeText: getChangeText(updated_at),
          isPositive: true,
          icon: <img src={levelIcon} alt="Level icon" width="64" height="65" />,
          iconBg: '#e5e7eb'
        }
      : null
  ].filter(Boolean) // Filter out null values for global board

  return (
    <div className="stats-cards">
      {statsData.map(stat => (
        <div key={stat.id} className="stats-card">
          <div className="stats-card-content">
            <div className="stats-info">
              <div className="stats-value">{stat.value}</div>
              <div className="stats-title">{stat.title}</div>
              {/* <div className="stats-change">
                                <span className={`change-indicator ${stat.isPositive ? 'positive' : 'negative'}`}>
                                    ↗ {stat.change}
                                </span>
                                <span className="change-text">{stat.changeText}</span>
                            </div> */}
            </div>
            <div className="stats-icon">{stat.icon}</div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default StatsCards
